(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-catalog"] && !Shopify.designMode) return;
  try {
    
function initializeDropCards(root) {
  root.querySelectorAll('.dc-card').forEach((card) => {
    if (card.dataset.ready) return;
    const slots = card.querySelector('[data-drop-slots]');
    const source = card.querySelector('[data-drop-images]');
    if (!slots || !source) return;
    const images = Array.from(source.content.querySelectorAll('img'));
    const visible = Array.from(slots.querySelectorAll('img'));
    if (!images.length) return;
    card.dataset.ready = 'true';
    let offset = 0;
    let busy = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const copyImage = (target, sourceImage) => {
      ['sizes', 'srcset', 'src', 'alt'].forEach((attribute) => {
        if (sourceImage.hasAttribute(attribute)) target.setAttribute(attribute, sourceImage.getAttribute(attribute));
        else target.removeAttribute(attribute);
      });
    };
    card.querySelectorAll('[data-drop-step]').forEach((button) => {
      button.disabled = images.length < 2;
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (busy) return;
        busy = true;
        const direction = Number(button.dataset.dropStep);
        const nextOffset = (offset + direction + images.length) % images.length;
        const nextImages = visible.map((_, i) => images[(nextOffset + i) % images.length]);
        const probes = nextImages.map((image) => {
          const probe = new Image();
          copyImage(probe, image);
          probe.loading = 'eager';
          return probe;
        });
        let layer;
        try {
          await Promise.all(probes.map((image) => image.decode().catch(() => {})));
          if (!card.isConnected) return;
          const parent = slots.getBoundingClientRect();
          const boxes = visible.map((image) => {
            const box = image.getBoundingClientRect();
            return { x: box.left - parent.left, y: box.top - parent.top,
              w: box.width, h: box.height, filter: getComputedStyle(image).filter };
          });
          if (!reducedMotion.matches && parent.width && parent.height) {
            layer = document.createElement('div');
            layer.setAttribute('aria-hidden', 'true');
            layer.style.cssText = 'position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:1';
            slots.appendChild(layer);
            const outside = (side) => {
              const edge = boxes[side < 0 ? 0 : boxes.length - 1];
              return { ...edge, x: side < 0 ? -edge.w - 12 : parent.width + 12 };
            };
            const frame = (box) => ({
              transform: 'translate(' + box.x + 'px,' + box.y + 'px)',
              width: box.w + 'px', height: box.h + 'px', filter: box.filter
            });
            const animateImage = (image, from, to) => {
              const clone = image.cloneNode();
              clone.loading = 'eager';
              clone.style.cssText = 'position:absolute;left:0;top:0;max-width:none;margin:0;object-fit:cover;aspect-ratio:auto;border-radius:10px;will-change:transform,width,height';
              Object.assign(clone.style, frame(from));
              layer.appendChild(clone);
              return clone.animate([frame(from), frame(to)], {
                duration: 460, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards'
              }).finished;
            };
            const animations = visible.map((image, index) => {
              const destination = index - direction;
              return animateImage(image, boxes[index],
                destination < 0 ? outside(-1) : destination >= boxes.length ? outside(1) : boxes[destination]);
            });
            const entering = direction > 0 ? boxes.length - 1 : 0;
            animations.push(animateImage(probes[entering], outside(direction), boxes[entering]));
            visible.forEach((image) => { image.style.visibility = 'hidden'; });
            await Promise.all(animations);
          }
          visible.forEach((image, index) => copyImage(image, nextImages[index]));
          await Promise.all(visible.map((image) => image.decode().catch(() => {})));
          offset = nextOffset;
        } finally {
          visible.forEach((image) => { image.style.visibility = ''; });
          if (layer) layer.remove();
          busy = false;
        }
      });
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeDropCards(document),{once:true});else initializeDropCards(document);
document.addEventListener('shopify:section:load', (event) => initializeDropCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallpaper-studio"] && !Shopify.designMode) return;
  try {
    
function randomizeHero(root){
 root.querySelectorAll('.wp-showcase').forEach(showcase=>{
  if(showcase.dataset.randomized)return;showcase.dataset.randomized='true';
  const choose=async(kind,selector)=>{
   const template=showcase.querySelector('[data-hero-'+kind+']');
   if(!template)return;
   const sources=[...template.content.querySelectorAll('img')];
   if(!sources.length)return;
   const targets=[...showcase.querySelectorAll(selector)];
   const key='wallpaper-hero-'+kind;
   let last=[];try{last=JSON.parse(sessionStorage.getItem(key)||'[]');}catch{}
   const candidates=sources.filter(image=>!last.includes(image.getAttribute('src')));
   const pool=candidates.length>=targets.length?candidates:[...sources];
   for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
   const picked=targets.map((_,i)=>pool[i%pool.length]);
   try{sessionStorage.setItem(key,JSON.stringify(picked.map(image=>image.getAttribute('src'))));}catch{}
   await Promise.all(targets.map(async(target,i)=>{
    const source=picked[i];const image=new Image();image.loading='eager';
    image.src=source.getAttribute('src');image.alt=source.getAttribute('alt')||'';
    try{await image.decode();if(!target.isConnected)return;target.replaceChildren(image);const link=target.closest('a');const item=source.parentElement;if(link&&item.dataset.dropUrl){link.href=item.dataset.dropUrl;link.setAttribute('aria-label',item.dataset.dropTitle);}}catch{}
   }));
  };
  choose('phone','.wp-wallpaper');choose('desktop','.wp-laptop-image');
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>randomizeHero(document),{once:true});else randomizeHero(document);
document.addEventListener('shopify:section:load',event=>randomizeHero(event.target));

  } catch(e) { console.error(e); }
})();
})();
